import { render, staticRenderFns } from "./downloadPage.vue?vue&type=template&id=2d22d7b5"
import script from "./downloadPage.vue?vue&type=script&lang=js"
export * from "./downloadPage.vue?vue&type=script&lang=js"
import style0 from "./downloadPage.vue?vue&type=style&index=0&id=2d22d7b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports